var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Refresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(8.53333 8.53333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3c-2.9686 0-5.69718 1.08344-7.79297 2.875-.28605.22772-.42503.59339-.36245.95363.06258.36023.31676.6576.66286.77549.3461.1179.72895.03753.99842-.20959C9.25407 6.90056 11.5166 6 14 6c5.19656 0 9.45099 3.93793 9.95117 9H21l4 6 4-6h-3.05078C25.4379 8.85166 20.2778 4 14 4zm-11 7-4 6h3.05078C3.56207 22.1483 8.72216 27 15 27c2.9686 0 5.69718-1.08344 7.79297-2.875.28605-.22772.42504-.59339.36245-.95363-.06258-.36023-.31676-.6576-.66286-.7755-.3461-.1179-.72895-.03753-.99842.20959C19.7459 24.0994 17.4834 25 15 25c-5.19656 0-9.45099-3.93793-9.95117-9H8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Refresh);
export default __webpack_public_path__ + "static/media/icons8-refresh.a03abef3bc6a7a384e421c40459c5313.svg";
export { ForwardRef as ReactComponent };